// ** Handles Layout Content Width (full / boxed)
export const handleContentWidth = (value) => (dispatch) =>
  dispatch({ type: "HANDLE_CONTENT_WIDTH", value });

// ** Handles Menu Collapsed State (Bool)
export const handleMenuCollapsed = (value) => (dispatch) =>
  dispatch({ type: "HANDLE_MENU_COLLAPSED", value });

// ** Handles Menu Hidden State (Bool)
export const handleMenuHidden = (value) => (dispatch) =>
  dispatch({ type: "HANDLE_MENU_HIDDEN", value });

// ** Handles RTL (Bool)
export const handleRTL = (value) => (dispatch) =>
  dispatch({ type: "HANDLE_RTL", value });
export const handleOrg = (value) => (dispatch) => {
  return dispatch({ type: "Active_Org", value });
};
export const createOrg = (value) => (dispatch) => {
  return dispatch({ type: "Create_Org", value });
};

export const setAllOrgs = (value) => (dispatch) => {
  return dispatch({ type: "set_all_user_organizations", value });
};
export const hanleDeleteOP = (value) => (dispatch) => {
  return dispatch({ type: "Delete_Operation", value });
};
export const clearDeleteOp = () => (dispatch) => {
  return dispatch({ type: "Clear_Delete_Operation" });
};
export const handleRestoreOP = (value) => (dispatch) => {
  return dispatch({ type: "Restore_Operation", value });
};
export const clearRestoreOp = () => (dispatch) => {
  return dispatch({ type: "Clear_Restore_Operation" });
};
export const handleUser = (value) => (dispatch) =>
  dispatch({ type: "User_Data", value });
export const handleUserNotification = (value) => (dispatch) => {
  dispatch({ type: "User_Noti", value });
};
export const handleNotiCount = (value) => (dispatch) => {
  dispatch({ type: "noti_count", value });
};
export const handleSessionEvent = (value) => (dispatch) => {
  dispatch({ type: "handle_event", value });
};

/**
 * SETTING ALL ORGANIZATIONS OF LOGIN USER
 * @param {Array} value
 */
export const setAllUserOrganizations = (value) => (dispatch) => {
  dispatch({ type: "set_all_user_organizations", value });
};

/**
 * UPDATE THEME SETTIGNS
 * @param {Object} value
 */
export const updateThemeSettings = (value) => (dispatch) => {
  dispatch({ type: "update_theme_settings", value });
};

/**
 * SET DYNAMIC LABELS
 * @param {Object} value
 */
export const setDynamicLabels = (value) => (dispatch) => {
  dispatch({ type: "set_dynamic_labels", value });
};

/**
 * UPDATE APP TRANSLATION
 * @param {Object} value
 */
export const updateAppTranslation = (value) => (dispatch) => {
  dispatch({ type: "update_app_translation", value });
};
